import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Tab } from "@mui/material";
import { useState } from "react";
import FundAdminProvisioning from "./FundAdminProvisioning";
import FundAdminBcPermissionsSync from "./FundAdminBcPermissionsSync";
import FundManagerProvisioning from "./FundManagerProvisioning";
import FundManagerDeprovisioning from "./FundManagerDeprovisioning";

type TabValue = "FundAdmin" | "FundManager" | "FundManagerDeprovision" | "FundAdminBcPermissionsSync";

const ClientProvisioningContent = () => {
  const [selectedTab, setSelectedTab] = useState<TabValue>("FundAdmin");

  return (
    <TabContext value={selectedTab}>
      <TabList onChange={(_, value: TabValue) => setSelectedTab(value)}>
        <Tab label="Fund Admin" value="FundAdmin" />
        <Tab label="Fund Manager" value="FundManager" />
        <Tab label="Deprovision Fund Manager" value="FundManagerDeprovision" />
        <Tab label="Sync BC Permissions" value="FundAdminBcPermissionsSync" />
      </TabList>
      <TabPanel value="FundAdmin">
        <FundAdminProvisioning />
      </TabPanel>
      <TabPanel value="FundManager">
        <FundManagerProvisioning />
      </TabPanel>
      <TabPanel value="FundManagerDeprovision">
        <FundManagerDeprovisioning />
      </TabPanel>
      <TabPanel value="FundAdminBcPermissionsSync">
        <FundAdminBcPermissionsSync />
      </TabPanel>
    </TabContext>
  );
};

export default ClientProvisioningContent;
